module.exports = __webpack_public_path__ + "img/bg1.68445ad2.png";